import { render, staticRenderFns } from "./WYSIWYGHtmlElement.vue?vue&type=template&id=b52038e4&scoped=true&"
import script from "./WYSIWYGHtmlElement.vue?vue&type=script&lang=js&"
export * from "./WYSIWYGHtmlElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52038e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b52038e4')) {
      api.createRecord('b52038e4', component.options)
    } else {
      api.reload('b52038e4', component.options)
    }
    module.hot.accept("./WYSIWYGHtmlElement.vue?vue&type=template&id=b52038e4&scoped=true&", function () {
      api.rerender('b52038e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/WYSIWYGHtmlElement.vue"
export default component.exports